export { AddonMeta, PackageInfo } from './metadata';
export {
  explicitRelative,
  extensionsPattern,
  unrelativize,
  cleanUrl,
  getUrlQueryParams,
  correspondingTemplate,
} from './paths';
export { getOrCreate } from './get-or-create';
export { default as Package, V2AddonPackage as AddonPackage } from './package';
export { default as PackageCache, type PackageCachePublicAPI } from './package-cache';
export type { RewrittenPackageIndex } from './rewritten-package-cache';
export { RewrittenPackageCache } from './rewritten-package-cache';
export { default as packageName } from './package-name';
export { default as tmpdir } from './tmpdir';
export * from './ember-cli-models';
export * from './ember-standard-modules';
export { hbsToJS } from './hbs-to-js';
export {
  default as templateColocationPlugin,
  Options as TemplateColocationPluginOptions,
  pluginPath as templateColocationPluginPath,
} from './template-colocation-plugin';

export {
  default as cacheBustingPlugin,
  pluginPath as cacheBustingPluginPath,
  version as cacheBustingPluginVersion,
} from './babel-plugin-cache-busting';
export { locateEmbroiderWorkingDir } from './working-dir';

export * from './dep-validation';
export * from './colocation';
export { getWatchedDirectories } from './watch-utils';
